/**
 * @ngdoc directive
 * @name sgNavigationCtrl.controller
 *
 * @description
 * sgNavigationCtrl houdt het menu up to date,
 * zorgt dat het menu / submenu wordt weergegeven of verborgen
 * vernieuwt het submenu als nodig, zorgt dat het juiste submenu item geselecteerd (tab onderstreept) is.
 * Om de zorgen dat een submenu wordt weergegeven bij een bepaalde pagina zet je de propery 'menuContext'
 * in de route configuratie
 * bijv: menuContext: 'project' voor deze context moeten dat wel items bestaan in Menu (komt uit backend), dus:
 *     menuData.projectMenuItems = [array van menu items]
 *
 * De titel en de subTitle in het menu kunnen worden aangepast in de configuratie.
 *   voeg de property 'menuTitle' en/of 'menuSubtitle' toe, bijv  menuTitle :'Mijn projecten'
 *
 * bij de project pagina's en de gebruiker pagina wordt de infomatie voor de menuTitle uit de injectors
 * van de state gehaald
 * (naam van project / gebruiker)
 *
 */

'use strict';

(function () {
  angular
    .module('specsguardApp')
    .controller('sgNavigationCtrl', sgNavigationCtrl);

  sgNavigationCtrl.$inject = ['$scope', 'Auth', '$transitions', 'Menu', '$stateParams', 'sg2CircularDetectionService',
    '$location', '$mdPanel', 'ProjectDataservice', '$log', 'Labels', 'sgNavigationLabelReplacesFactory', 'sg2ModalService'];

  function sgNavigationCtrl ($scope, Auth, $transitions, Menu, $stateParams, sg2CircularDetectionService,
    $location, $mdPanel, ProjectDataservice, $log, Labels, sgNavigationLabelReplacesFactory, sg2ModalService) {

    const vm = this;
    vm.submenuItems = [];
    vm.showSubmenu = true;
    vm.buildings = null;
    vm.isLoggedIn = Auth.isLoggedIn();

    vm.$stateParams = $stateParams;
    // vm.accessLevel = Auth.getUserAccessLevel();

    $scope.$on('loggedOut', () => {
      vm.isLoggedIn = false;
    });

    $scope.$on('loggedIn', () => {
      vm.isLoggedIn = true;
      vm.hideMenu = false;
    });

    $scope.$on('hideMenu', function (evnt, data) {
      vm.hideMenu = data;
    });

    let accessLevel = -1;
    let projectRole = '';
    let buildingId = -1;
    let currentProject = -1;
    let menuData;

    vm.handleStateChange = function (trans) {
      menuData = Menu.getAll();
      Labels.translateMenuData(menuData);

      vm.checkUserStatus();
      vm.closeSubSubMenu();
      let state = trans.to();
      let newContext;
      let hasProject;
      let projectId;
      let hasBuilding;
      let building;
      let buildingName;
      let hasArea;
      let areaId;
      let areaName;
      let hasBasicArea;
      let basicAreaId;
      let basicAreaName;

      if (state.menu) {
        newContext = state.menu.context;
        vm.menuIcon = state.menu ? state.menu.icon : null;
      } else {
        $log.warn('menu object missing in state:', state.url);
      }
      vm.initial = '';
      vm.context = state.menu.context;

      switch (newContext) {
        case 'project':

          hasProject = /^\/project\/([0-9a-fA-F]{24})\//.exec($location.path());
          if (hasProject) {
            projectId = hasProject[1];

            hasBuilding = /\/building\/([0-9a-fA-F]{24}|new)\//.exec($location.path());
            buildingId = hasBuilding ? hasBuilding[1] : 0;

            if (hasBuilding) {
              hasArea = /\/areas\/([0-9a-fA-F]{24})/.exec($location.path());
              areaId = hasArea ? hasArea[1] : 0;
            }

            hasBasicArea = /\/basic-areas\/([0-9a-fA-F]{24})/.exec($location.path());
            basicAreaId = hasBasicArea ? hasBasicArea[1] : 0;
          }


          if (state.menu) {
            trans.injector().getAsync('project').then((project) => {

              if (hasBuilding) {
                building = project.buildings.find((_building) => _building._id === buildingId);
                buildingName = building && building.name;
                if (hasArea) {
                  let areas = building.clusters.reduce((array, cluster) => array.concat(cluster.areas), []);
                  areaName = areas.find((area) => area._id === areaId).name;
                }
              }

              if (hasBasicArea) {
                const basicArea = project.basicAreas.find((_basicArea) => _basicArea._id === basicAreaId);
                basicAreaName = basicArea.name;
              }

              vm.pageTitle = sgNavigationLabelReplacesFactory.projectTitle(state.menu.title, project);
              if (state.menu.subtitle) {
                vm.subTitle = sgNavigationLabelReplacesFactory
                  .projectSubTitle(state.menu.subtitle, areaName, basicAreaName, buildingName);
              }
              vm.initial = project.name[0].toUpperCase();
            });
          }

          break;

        case 'users':
          sgNavigationLabelReplacesFactory.user(state.menu, trans, vm);
          break;

        case 'userdetail':
          sgNavigationLabelReplacesFactory.userDetail(state.menu, trans, vm);
          break;

        case 'tenants':
          sgNavigationLabelReplacesFactory.tenants(state.menu, trans, vm);
          break;

        case 'textual_template':
        case 'technical_template':
          sgNavigationLabelReplacesFactory.template(state.menu, trans, vm);
          break;

        default:
          if (state.menu && state.menu.title) {
            vm.pageTitle = (state.menu.title || '')
              .replace('[Tenants]', Labels.getPlural('tenant'))
              .replace('[Project toevoegen]', Labels.getLabel('addproject'))
              .replace('[Projectlijst]', Labels.getLabel('projectlist')) || '';

            vm.subTitle = (state.menu.subtitle || '')
              .replace('[Tenants overview]', '');
          }
      }

      vm.refreshSubMenu(newContext, projectId);
    };

    vm.goToV2 = (): void => {
      const projectId = vm.$stateParams.projectId || vm.$stateParams.project_id;
      window.location.href = '/v2/project/' + projectId + '/dashboard';
    };

    /**
     * Detect Circulars on current page.
     */
    vm.findCirculars = (): void => {
      sg2CircularDetectionService.findInScope();
      sg2CircularDetectionService.findInStore();
    };

    vm.checkUserStatus = () => {
      const _loggedIn = Auth.isLoggedIn();
      if (vm.isLoggedin !== _loggedIn) {
        vm.isLoggedIn = _loggedIn;
        if (_loggedIn) {
          vm.user = Auth.getCurrentUser();
          accessLevel = Auth.getUserAccessLevel();
          vm.mainMenuItems = menuData.mainMenuItems.filter((item) => item.accessLevel <= accessLevel)
        }
      }
    };

    vm.refreshSubMenu = function (newContext, projectId) {
      vm.buildings = null;
      if (vm.menuContext !== newContext || currentProject !== projectId) {
        vm.menuContext = newContext;
        currentProject = projectId;
        if (newContext === 'project' && projectId !== -1) {
          ProjectDataservice.getProjectById(currentProject)
            .then(function (project) {
              projectRole = Auth.getUserProjectRole(project);
              vm.updateSubMenuItems();
            });
        } else {
          vm.updateSubMenuItems();
        }
      } else {
        // update the selected item in submenu when navigation occurs without use of the submenu
        vm.setActiveSubmenuItem();
      }
    };

    vm.updateSubMenuItems = function () {

      const menuItems = menuData[vm.menuContext + 'MenuItems'];
      const showSubmenu = vm.isLoggedIn && menuItems;
      vm.submenuItems = [];

      if (showSubmenu) {
        menuItems.forEach(
          function (item) {
            const itemProjRoles = item.accessLevelProjectRoles && item.accessLevelProjectRoles.split(',');

            if (item.accessLevel <= accessLevel || (itemProjRoles && itemProjRoles.indexOf(projectRole) > -1)) {
              const newItem = Object.assign({}, item);
              newItem.link = item.link.replace('[projectId]', currentProject);
              if (newItem.addButton) {
                const btn = Object.assign({}, item.addButton);
                const addButtonRoles = btn.accessLevelProjectRoles && btn.accessLevelProjectRoles.split(',');

                if (btn.accessLevel <= accessLevel || addButtonRoles.indexOf(projectRole) > -1) {
                  btn.link = item.addButton.link.replace('[projectId]', currentProject);
                  newItem.addButton = btn;
                } else {
                  delete newItem.addButton;
                }
              }
              vm.submenuItems.push(newItem);
            }
          }
        );
      }
      vm.showSubmenu = showSubmenu;
      vm.setActiveSubmenuItem();
    };

    // puts the bar under the active tab
    vm.setActiveSubmenuItem = function () {
      let item;
      for (let i = 0; i < vm.submenuItems.length; i++) {
        item = vm.submenuItems[i];
        if ($location.path().indexOf(item.link.replace('[buildingId]', buildingId)) === 0) {
          vm.currentNavItem = item.title;
          break;
        }
      }
    };

    vm.openSubSubMenu = (idx, item) => {
      if (vm.buildings) {
        vm.openSubSubMenuPanel(idx, item);
      } else {
        ProjectDataservice.getProjectById(currentProject)
          .then((project) => {
            vm.buildings = [];
            for (const key in project.buildings) {
              if (project.buildings[key]) {
                const building = project.buildings[key];
                vm.buildings.push({
                  name: building.name,
                  id: building._id
                });
              }
            }

            vm.openSubSubMenuPanel(idx, item);
          });
      }
    };

    vm.openSubSubMenuPanel = function (idx, item) {
      const smData = vm.submenuItems[idx];
      let items = [];
      let items2 = [];

      // When no building is active, the user can't open this menu
      if (!vm.buildings.length) {
        const modalService = sg2ModalService.confirm({
          title: Labels.getLabel('addbuilding'),
          content: Labels.getLabel('nobuildingfound'),
          actions: [{
            action: 'confirm',
            label: Labels.getLabel('addbuilding')
          }]
        });

        // Refer the user to the administration page whenever the confirm button is clicked
        modalService.afterClosed().subscribe((click: any) => {
          if (click === 'confirm') {
            $location.path(`/project/${currentProject}/building/new`);
          }
        });
      }
      vm.buildings.forEach((building) => {
        const namePrefix = item._id === 24 ? `${Labels.getLabel('arealist')}: ` : '';
        const namePrefix2 = item._id === 24 ? `${Labels.getLabel('areamatrix')}: ` : '';

        items.push(
          {
            name: namePrefix + building.name,
            link: smData.link.replace('[buildingId]', building.id)
          }
        );

        items2.push(
          {
            name: namePrefix2 + building.name,
            link: smData.addButton.link.replace('[buildingId]', building.id)
          }
        );
      });

      const button = angular.element(document.getElementById('ssmenu' + smData._id));
      const position = $mdPanel.newPanelPosition()
        .relativeTo(button)
        .addPanelPosition($mdPanel.xPosition.ALIGN_START, $mdPanel.yPosition.BELOW);

      const config = {
        id: 'ssmPanel',
        controller: function () { },
        controllerAs: 'ctrl',
        template: `<md-content class="md-whiteframe-3dp sg-sub-sub-menu">
          <md-list>
            <md-list-item ng-repeat="item in ctrl.ssmItems" ng-href="{{item.link}}">
              <p>{{ item.name }}</p>
            </md-list-item>
            <md-divider ng-if="ctrl.ssMenu.addButton"></md-divider>
            <md-list-item ng-repeat="item2 in ctrl.ssmItems2" ng-href="{{item2.link}}">
              <p>{{ item2.name }}</p>
            </md-list-item>
            <!--<md-list-item-->
              <!--ng-if="ctrl.ssMenu.addButton"-->
              <!--ng-href="{{ctrl.ssMenu.addButton.link}}"-->
              <!--name="{{ctrl.ssMenu.addButton.title}}"-->
            <!--&gt;-->
              <!--<p>{{ctrl.ssMenu.addButton.title}}</p>-->
              <!--<md-icon ng-if="ctrl.ssMenu.addButton.icon" aria-label="toevoegen" class="md-accent">-->
                <!--{{ctrl.ssMenu.addButton.icon}}-->
              <!--</md-icon>-->
            <!--</md-list-item>-->
          </md-list>
        </md-content>`,
        onCloseSuccess: function () {
          vm.setActiveSubmenuItem();
        },
        position: position,
        locals: {
          ssmItems: items,
          ssmItems2: items2,
          ssMenu: smData
        },
        openFrom: button,
        clickOutsideToClose: true,
        escapeToClose: true,
        focusOnOpen: false,
        zIndex: 2000
      };

      vm.ssPanel = $mdPanel.open(config);
    };

    vm.closeSubSubMenu = () => {
      vm.ssPanel && vm.ssPanel.then((panel) => panel.close());
    };

    $transitions.onSuccess({}, (trans) => {
      vm.isLoggedIn = Auth.isLoggedIn();
      if (vm.isLoggedIn) {
        vm.handleStateChange(trans);
      }
    });
  }

})();
